import { ServiceExecutionSequenceModel } from 'app/app-model/diagnostic-service/service-execution-sequence.model';
import { SecurityAccessModel } from 'app/app-model/security-access/security-access.model';

export class FlashModel {
  name: string;
  setSequence: ServiceExecutionSequenceModel;
  securityAccessModeName: string | null;
  securityAccessMode: SecurityAccessModel;
  availableSecurityAccessModes: string[] = [];
}
